import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'zr-button',
  template: `
  <button type="button" class="btn {{bg}}" (click)="click()" 
    [disabled]="disabled" [ngClass]="{'dropdown-toggle':toggle,'m-btn--air':shadow,
    'btn-sm':size==='sm','btn-lg':size==='lg','m-btn--square':borderRadius==='square',
    'm-btn--pill':borderRadius==='pill'}">
    <i class="{{icon}}"></i>
    {{text}}
  </button>
  `
})
export class ZrButtonComponent implements OnInit {
  @Input() text?: string = 'button';
  @Input() data?: any;
  @Input() size?: string = ''; // button size ['btn-lg'，'btn-sm']
  @Input() bg?: string = 'btn-secondary';
  @Input() disabled?: boolean = false;
  @Input() icon?: string = '';
  @Input() borderRadius?: string = ''; // button border radius ['m-btn--square'，'m-btn--pill']
  @Input() shadow?: boolean = false; // button shadow
  @Input() toggle?: boolean = false;

  @Output() clickEventer = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  click() {
    this.clickEventer.emit(this.data);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/zr-button/zr-button.component.ts